import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  applyIncrease,
  getBankName,
  getContractData,
  getInvoices,
  getMmps,
  getPrincipalBalance,
  getProductPrincipal,
  getUpgradeEligibility,
  getUpsellEligibility,
  sendDrawAmount,
  setUpgradeHighlightOff,
  setUpgradeSuccessOff,
  cancelUpdateData,
} from 'actions/selfservice';
import InvoicesSection from 'components/Credit24/SelfService/Dashboard/InvoicesSection';
import WithdrawalSection from 'components/Credit24/SelfService/Dashboard/WithdrawalSection';
import PaymentHolidaySection from 'components/Credit24/SelfService/Dashboard/PaymentHolidaySection';
import ContractStatusSection from 'components/Credit24/SelfService/Dashboard/ContractStatusSection';
import RepaymentInfoSection from 'components/Credit24/SelfService/Dashboard/RepaymentInfoSection';
import ContractStatus from 'components/Credit24/SelfService/ContractStatus';
import { isMobile } from 'utils/helpers';
import { UpdateDataModal } from 'components/Credit24/SelfService/UpdateDataModal';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  getInvoices: PropTypes.func,
  getContractData: PropTypes.func,
  getMmps: PropTypes.func,
  getBankName: PropTypes.func,
  getProductPrincipal: PropTypes.func,
  getPrincipalBalance: PropTypes.func,
  getUpgradeEligibility: PropTypes.func,
  getUpsellEligibility: PropTypes.func,
  applyIncrease: PropTypes.func,
  setUpgradeHighlightOff: PropTypes.func,
  setUpgradeSuccessOff: PropTypes.func,
  cancelUpdateData: PropTypes.func,
};

class DashboardContainer extends Component {
  componentDidMount() {
    const { bankAccount, contracts = [] } = this.props.authentication;
    contracts.forEach((contractId) => {
      this.props.getContractData(contractId, false, (contract) => {
        if (COUNTRY === 'AU') {
          if (contract.product.type === 'INSTALLMENT') {
            this.props.getProductPrincipal(contractId, contract.startDate);
            this.props.getPrincipalBalance(contractId);
            this.props.getUpsellEligibility(contractId);
          } else {
            this.props.getUpgradeEligibility(contractId);
          }
        }
      });
      this.props.getInvoices(contractId);
      this.props.getMmps(contractId);
    });
    this.props.getBankName(bankAccount);
  }

  render() {
    const { authentication, selfservice } = this.props;
    const { isUpgradeHighlighted, shouldUpdateModalOpen } = selfservice;
    const { isInCollection } = authentication;
    const contractId = authentication.contracts[0];
    const contract = selfservice.contracts[contractId];
    const isContractFrozen = contract
      && contract.CONTRACT_FREEZE
      && contract.CONTRACT_FREEZE.enabled;
    let isProductInstallmentAU = false;
    let isProductLoadedAU = true;

    const { address, email, msisdn } = authentication.expiredData;
    const isModalOpen = shouldUpdateModalOpen && !isInCollection && (address || email || msisdn);

    if (COUNTRY === 'AU') {
      isProductLoadedAU = !!(contract && contract.product);
      isProductInstallmentAU = isProductLoadedAU && contract.product.type === 'INSTALLMENT';
    }

    if (!contract || !contract.id) {
      return null;
    }

    const invoices = selfservice.invoices[contractId] || {};

    return (
      <>
        {!isInCollection && (!isProductInstallmentAU || contract.principalBalance)
          && (
          <ContractStatusSection
            authentication={authentication}
            selfservice={selfservice}
            setUpgradeHighlightOff={this.props.setUpgradeHighlightOff}
            applyIncrease={this.props.applyIncrease}
          />
          )}
        {!isProductInstallmentAU
          && (
          <WithdrawalSection
            {...this.props}
            contract={contract}
            isUpgradeHighlighted={isUpgradeHighlighted && selfservice.isNativeAdvertisingEnabled}
          />
          )}
        {isMobile && (!isProductInstallmentAU || contract.principalBalance)
          && (
          <div className="content-block">
            <ContractStatus
              authentication={authentication}
              selfservice={selfservice}
              setUpgradeHighlightOff={this.props.setUpgradeHighlightOff}
              setUpgradeSuccessOff={this.props.setUpgradeSuccessOff}
              isInDashboard
              applyIncrease={this.props.applyIncrease}
            />
          </div>
          )}
        <UpdateDataModal
          authentication={authentication}
          isOpen={isModalOpen}
          ocClose={this.props.cancelUpdateData}
        />
        <InvoicesSection invoices={invoices} contract={contract} />
        {COUNTRY === 'FI'
          && (
          <div className="grid">
            <div className="grid__item one-half palm-one-whole">
              <PaymentHolidaySection
                service={contract.PAYMENT_HOLIDAY}
                isContractFrozen={isContractFrozen}
              />
            </div>
          </div>
          )}
        {COUNTRY === 'AU'
          && <RepaymentInfoSection customerNumber={authentication.customerNumber} />}
      </>
    );
  }
}

DashboardContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    selfservice: state.selfservice,
    authentication: state.authentication,
  }),
  {
    getInvoices,
    getContractData,
    getMmps,
    sendDrawAmount,
    setUpgradeHighlightOff,
    setUpgradeSuccessOff,
    getBankName,
    getProductPrincipal,
    getPrincipalBalance,
    getUpgradeEligibility,
    getUpsellEligibility,
    applyIncrease,
    cancelUpdateData,
  }
)(DashboardContainer);
